import React from "react";
import * as R from "ramda";
import { Skeleton } from "antd";

import { SkeletonCandidates } from "../OpportunityCandidates/Skeleton";

import { Container, ProcessContent } from "./OpportunityProcess";

import styled from "styled-components/macro";

const SkeletonColumn = styled.div`
  background: #f0f1f5;
  padding: 0 20px;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  margin-inline: 8px;

  .skeleton-title {
    margin-bottom: 20px;
  }

  .skeleton-card .ant-skeleton-title {
    height: 150px;
    margin: 0;
  }
`;

const SkeletonItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.5s ease;
  overflow: hidden;
  width: 100%;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .skeleton-profile {
    width: 100%;
  }
`;

const ProcessSkeleton = () => {
  return (
    <Container>
      <ProcessContent>
        {R.map(
          n => (
            <SkeletonColumn key={n}>
              <SkeletonItem className="skeleton-title">
                <Skeleton
                  active
                  avatar={false}
                  title={{ width: 120, rows: 1 }}
                  paragraph={false}
                />
              </SkeletonItem>
              <SkeletonCandidates cardsNumber={2} />
            </SkeletonColumn>
          ),
          R.times(R.identity, 4)
        )}
      </ProcessContent>
    </Container>
  );
};

export default ProcessSkeleton;
